import {ComponentType, ReactElement} from "react";
import {Organization, Treatment, Patient, PatientCreate} from "../api-client";
import PatientForm, {PatientFormProps} from "../components/patient/PatientForm";
import PatientFormForeign from "../components/patient/PatientFormForeign";

/**
 * Form data type derived from generated API types:
 * - Base: PatientCreate (all create fields required/optional as per API contract)
 * - Extended: All additional Patient fields as optional (for edit mode)
 */
export type PatientFormData = PatientCreate & Partial<Omit<Patient, keyof PatientCreate>>;

export interface TreatmentDataType {
    key: string | undefined;
    date: string | undefined;
    procedure: ReactElement | undefined;
    tooth: string | undefined;
    sum: ReactElement | undefined;
    discount: ReactElement | undefined;
    total: ReactElement | undefined;
    patientId: string | undefined;
    treatment: Treatment | undefined;
}

export function getPatientFormComponent(userOrganization?: Organization): ComponentType<PatientFormProps> {
    return userOrganization?.country === 'BG' ? PatientForm : PatientFormForeign;
}